export enum UsersFiltersTypes {

    Email = 'email',
    FirstName = 'first_name',
    LastName = 'last_name',
    Active = 'active',

}